import getDomainSuffix from "utils/getDomainSuffix";

const domainSuffix = getDomainSuffix();

const neoauthBase = `https://login.${domainSuffix}/`;

const appUrl = `${window.location.protocol}//${window.location.host}/`;

const dashboard = `https://dashboard.${domainSuffix}/`;

const Settings = {
  authorizeUrl: `${neoauthBase}o/authorize/`,
  appUrl,
  clientId: import.meta.env.VITE_API_CLIENT_ID,
  dashboard,
  fullLoginUrl: "",
  revokeToken: `${neoauthBase}o/revoke_token/`,
};

Settings.fullLoginUrl = `${Settings.authorizeUrl}?response_type=token&client_id=${
  Settings.clientId
}&scope=read&redirect_uri=${Settings.appUrl}${window.location.pathname.substring(
  1,
)}${encodeURIComponent(window.location.search)}`;

export const queryParamsInUrl = (url: string, queryParams: string): string =>
  `${url}?${queryParams}`;

export default Settings;
